import { Checkbox, FormControlLabel } from "@mui/material";
import { FC } from "react";

interface IArchivedStagesSelectProps {
    includeArchivedStages: boolean | undefined,
    setIncludeArchivedStages: React.Dispatch<React.SetStateAction<boolean | undefined>>
}

const ArchivedStagesSelect: FC<IArchivedStagesSelectProps> = ({
    includeArchivedStages,
    setIncludeArchivedStages
}) => {
    return (
        <>
            <FormControlLabel 
                control={
                    <Checkbox 
                        onChange={event => setIncludeArchivedStages(event.target.checked)}
                        checked={includeArchivedStages ?? false}
                    />
                } 
                label={"Include Archived Stages"} 
            />
        </>
    );
    
}

export default ArchivedStagesSelect;